import Modal from "./Modal";
import SubscribeForm from "./SubscribeForm";

export default function SubscribeModal({ open, onClose, userType = "candidat" }) {
  const handleSuccess = () => {
    setTimeout(() => onClose(), 2000);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <SubscribeForm userType={userType} onSuccess={handleSuccess} />
    </Modal>
  );
}
